// src/pages/ArchivePage.js
import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { Link } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { useStats } from '../hooks/useStats';

const ArchivePage = () => {
    const [puzzles, setPuzzles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { stats } = useStats();

    useEffect(() => {
        const fetchPuzzles = async () => {
            const today = new Date().toISOString().split('T')[0];
            const { data, error } = await supabase
                .from('daily_puzzles')
                .select('puzzle_date, starter_word')
                .lt('puzzle_date', today) // Less than today
                .order('puzzle_date', { ascending: false });
            
            if (error) {
                console.error('Error fetching puzzles:', error);
            } else {
                setPuzzles(data || []);
            }
            setIsLoading(false);
        };
        fetchPuzzles();
    }, []);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <div className="flex flex-col items-center min-h-screen bg-background dark:bg-dark-background text-foreground dark:text-dark-foreground p-4">
             <header className="w-full max-w-2xl flex items-center mb-6">
                <Link to="/" className="text-2xl mr-4">
                    <IoArrowBack />
                </Link>
                <h1 className="text-2xl font-bold">Archive</h1>
            </header>

            <div className="w-full max-w-2xl space-y-4">
                {isLoading ? (
                    <p className="text-center">Loading archive...</p>
                ) : (
                    puzzles.map(puzzle => {
                        const result = stats.dailyResults[puzzle.puzzle_date];
                        let status = <span className="text-gray-500 font-bold">Unplayed</span>;
                        
                        if (result) {
                            if (result.status === 'won') status = <span className="text-green-500 font-bold">Won</span>; // Legacy support
                            else if (result.status === 'lost') status = <span className="text-red-500 font-bold">Lost</span>;
                            else if (result.medal) {
                                // Show medal instead of generic status
                                if (result.medal === 'platinum') status = <span className="text-green-500 font-bold">Platinum</span>;
                                else if (result.medal === 'gold') status = <span className="text-yellow-500 font-bold">Gold</span>;
                                else if (result.medal === 'silver') status = <span className="text-gray-400 font-bold">Silver</span>;
                                else if (result.medal === 'bronze') status = <span className="text-orange-500 font-bold">Bronze</span>;
                            } else if (result.status === 'played') {
                                status = <span className="text-yellow-500 font-bold">Played</span>;
                            }
                        }

                        return (
                            <Link 
                                key={puzzle.puzzle_date} 
                                to={`/game?date=${puzzle.puzzle_date}`} // Ensure query param is passed
                                className="block bg-gray-100 dark:bg-gray-800 p-4 rounded-lg hover:opacity-80 transition-opacity"
                            >
                                <div className="flex justify-between items-center">
                                    <div>
                                        <p className="font-bold text-lg">{formatDate(puzzle.puzzle_date)}</p>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">Starter: {puzzle.starter_word}</p>
                                    </div>
                                    <div className="flex items-center space-x-4">
                                        {status}
                                        <span className="bg-accent dark:bg-dark-accent text-background dark:text-dark-background px-4 py-2 rounded-lg font-bold">
                                            Play
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default ArchivePage;
